export default __webpack_public_path__ + "static/media/doctor.e4c938c5.png";